// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineLearningTab_root__ReIxA","list":"MantineLearningTab_list__cULc5","tab":"MantineLearningTab_tab__MeVQV","panel":"MantineLearningTab_panel__l2D51"};